import Container from './components/Container';
import './products/config';

/* istanbul ignore next */
if (global.BROWSER && typeof window.IntersectionObserver === 'undefined') {
  // eslint-disable-next-line global-require -- require is only used in the browser
  require('intersection-observer');
}
export default Container;
;
if (!global.BROWSER) {
  Container.appConfig = Object.assign({}, Container.appConfig, {
    appCompatibility: "^5.0.0",
  });
}
;
Container.appConfig = Object.assign({}, Container.appConfig, {
  providedExternals: {
    
      '@americanexpress/browser-performance-mark': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '3.0.0',
        module: require('@americanexpress/browser-performance-mark'),
      }, 

      '@americanexpress/data-manager-utils': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.4.2',
        module: require('@americanexpress/data-manager-utils'),
      }, 

      '@americanexpress/myca-essentials': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '3.3.0',
        module: require('@americanexpress/myca-essentials'),
      }, 

      '@americanexpress/one-app-module-wrapper': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '3.5.0',
        module: require('@americanexpress/one-app-module-wrapper'),
      }, 

      '@americanexpress/one-experiments': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.3.5',
        module: require('@americanexpress/one-experiments'),
      }, 

      '@americanexpress/product-ducks': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.3.3',
        module: require('@americanexpress/product-ducks'),
      }, 

      '@americanexpress/react-ddl': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.1.8',
        module: require('@americanexpress/react-ddl'),
      }, 

      '@americanexpress/reactlytics': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.4.0',
        module: require('@americanexpress/reactlytics'),
      }, 

      '@emotion/core': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '10.1.1',
        module: require('@emotion/core'),
      }, 

      '@apollo/client': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '3.5.7',
        module: require('@apollo/client'),
      }, 

      'axp-browser-performance-mark': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '2.3.0',
        module: require('axp-browser-performance-mark'),
      }, 

      'axp-data-manager-utils': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.2.6',
        module: require('axp-data-manager-utils'),
      }, 

      'axp-myca-essentials': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.6.2',
        module: require('axp-myca-essentials'),
      }, 

      'axp-product-ducks': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.4.21',
        module: require('axp-product-ducks'),
      }, 

      'dayjs': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.11.7',
        module: require('dayjs'),
      }, 

      'iguazu': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '3.2.0',
        module: require('iguazu'),
      }, 

      'iguazu-graphql': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.3.0',
        module: require('iguazu-graphql'),
      }, 

      'iguazu-holocron': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.1.4',
        module: require('iguazu-holocron'),
      }, 

      'iguazu-rest': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.11.1',
        module: require('iguazu-rest'),
      }, 

      'iguazu-rpc': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.6.1',
        module: require('iguazu-rpc'),
      }, 

      'react-intl': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '3.12.1',
        module: require('react-intl'),
      }, 

      'reactlytics': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '1.2.5',
        module: require('reactlytics'),
      }, 

      '@americanexpress/one-xp-client-sdk': {
        ...{
  "fallbackEnabled": false,
  "enableFallback": false
},
        version: '0.12.1',
        module: require('@americanexpress/one-xp-client-sdk'),
      }
  },
});

if(global.getTenantRootModule === undefined || (global.rootModuleName && global.rootModuleName === 'axp-myca-root')){
global.getTenantRootModule = () => Container;
global.rootModuleName = 'axp-myca-root';
}
